import {
    format as formatWithTimezone,
    toZonedTime,
} from 'date-fns-tz';
import {
    format as formatWithoutTimezone,
    formatDistanceToNow as formatDistanceToNowWithoutTimezone,
    parseISO,
} from 'date-fns';

export const trackFathomPageview = function (url) {
    if (window.fathom && url) {
        try {
            fathom.trackPageview({
                                     url: url,
                                 });
        } catch (error) {
            console.error(error);
        }
    }
};

export const trackFathomEvent = function (event, details = undefined) {
    if (window.fathom) {
        try {
            fathom.trackEvent(event, details);
        } catch (error) {
            console.error(error);
        }
    }
};

export default {
    methods: {
        trackFathomPageview,
        trackFathomEvent,
    },
};